import { useNavigate } from "react-router-dom";
import { ECOSYSTEM } from "@/data/content";
import Icon from "@/components/Icon";

export default function EcosystemSection() {
  const navigate = useNavigate();
  const go = (key) => navigate(`/division/${key}`);

  return (
    <section className="section ecosystem" id="ecosystem" data-testid="ecosystem-section">
      <div className="container">
        <div className="sec-head">
          <div className="sec-head__left">
            <h2 className="sec-head__title">The PUMS Ecosystem<span className="sec-head__rule" /></h2>
            <p className="sec-head__sub">Integrated solutions. A stronger, healthier tomorrow.</p>
          </div>
          <div className="sec-head__rightwrap">
            <span className="sec-head__kicker">FIVE DIVISIONS. ONE PURPOSE.</span>
            <p className="sec-head__right">The Proactive UMS ecosystem delivers a complete continuum of care and technology through specialized divisions, united by a single corporate vision.</p>
          </div>
        </div>

        <div className="eco__grid">
          {ECOSYSTEM.map((c) => (
            <article
              key={c.key}
              className={`eco__card ${c.featured ? "eco__card--featured" : ""}`}
              data-testid={`eco-card-${c.key}`}
              onClick={() => go(c.key)}
              role="link"
              tabIndex={0}
              onKeyDown={(e) => (e.key === "Enter" ? go(c.key) : null)}
            >
              {c.featured && <span className="eco__ribbon" data-testid="eco-ribbon">{c.badge}</span>}
              <div className="eco__logo">
                <img src={c.logo} alt={c.title} loading="lazy" />
              </div>
              {c.title && <h3 className="eco__title">{c.title}</h3>}
              <p className="eco__phrase">{c.phrase}</p>
              {c.whatsInside && (
                <div className="eco__inside" aria-hidden="true">
                  <span className="eco__inside-inner">
                    <span className="eco__inside-label">What's inside</span>
                    {c.whatsInside}
                  </span>
                </div>
              )}
              <button
                className={`eco__btn ${c.featured ? "eco__btn--blue" : ""}`}
                onClick={(e) => { e.stopPropagation(); go(c.key); }}
                data-testid={`eco-btn-${c.key}`}
              >
                {c.cta} <Icon name="ArrowRight" size={14} />
              </button>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
